import { render } from "./zcfzb.vue?vue&type=template&id=20008842&scoped=true&ts=true"
import script from "./zcfzb.vue?vue&type=script&lang=ts"
export * from "./zcfzb.vue?vue&type=script&lang=ts"

import "./zcfzb.vue?vue&type=style&index=0&id=20008842&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20008842"]])

export default __exports__